import React from "react";
import { useLanguage } from "../../../i18n/LanguageContext";
import { SanityStepper } from "../../../model/common";
import { getStepData } from "../stepper";
import StepperCard from "./StepperCard/StepperCard";
import styles from "./StepperCards.module.scss";
import { usePathname } from "../../../utils/usePathname";

interface StepperCardsProps {
  node: SanityStepper;
}

const StepperCards = ({
  node: {
    stepperReference: { pages },
    text
  }
}: StepperCardsProps) => {
  const pathname = usePathname();
  const language = useLanguage();
  const stepData = getStepData(pages, pathname, language);
  return (
    <div className={styles.root}>
      {stepData
        .filter(step => !step.visited && !step.active)
        .map((step, index) => (
          <StepperCard
            key={step._id}
            {...step}
            nextStep={index === 0}
            text={text}
          />
        ))}
    </div>
  );
};

export default StepperCards;
